<ul class="mt-2 w-100 list-group">
    <li class="list-group-item subheader d-block align-items-center">
        <div class="d-flex align-items-center">
            <label class="form-check-label" for="flexCheckDefault" translate="Settings.AccountSecuritySection.Roles"></label>
        </div>
    </li>
    <li class="list-group-item d-block nohover align-items-center">
        <div class="d-flex align-items-center">
            <input class="form-check-input checkbox defaultheight" type="checkbox" value="" id="flexCheckDefault" checked disabled>
            <label class="form-check-label" for="flexCheckDefault" translate="Roles.Customer"></label>
        </div>
    </li>
    <li class="list-group-item d-block nohover align-items-center" *ngFor="let item of adminRightsCurrentUser; let i = index;">
        <app-user-roles-list-item [roleItem]="item" [userInRole]="roles.includes(item)" [adminRightsCurrentUser]="adminRightsCurrentUser"  [righsEditable]="righsEditable" (updateUserInRole)="updateRoles($event)"></app-user-roles-list-item>
    </li>
</ul>